import storesList from '@/store/modules/stores/stores-list'
import storesEdit from '@/store/modules/stores/stores-edit'
import storeDelete from '@/store/modules/stores/store-delete'
import storeCreate from '@/store/modules/stores/store-add'

export default {
  storesList,
  storesEdit,
  storeDelete,
  storeCreate,
}
